
// xilften-disable-local-streaming-server
(function () {
    const originalFetch = self.fetch ? self.fetch.bind(self) : null;

    function requestUrl(input) {
        if (typeof input === 'string') return input;
        if (input && typeof input.url === 'string') return input.url;
        if (input && typeof input.href === 'string') return input.href;
        return '';
    }

    function isLocalStreamingServer(url) {
        try {
            const parsed = new URL(url, self.location.href);
            return ['127.0.0.1', 'localhost'].includes(parsed.hostname) && parsed.port === '11470';
        } catch (_) {
            return false;
        }
    }

    function isDisabledStreamingServer(url) {
        try {
            const parsed = new URL(url, self.location.href);
            return parsed.origin === self.location.origin && parsed.pathname.startsWith('/disabled-streaming-server');
        } catch (_) {
            return false;
        }
    }

    function jsonResponse(payload) {
        return Promise.resolve(new Response(JSON.stringify(payload), {
            status: 200,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'Origin, Content-Type, Accept, Range',
                'Access-Control-Allow-Methods': 'GET, HEAD, POST, OPTIONS'
            }
        }));
    }

    function localStreamingServerPayload(url, method) {
        const parsed = new URL(url, self.location.href);
        const path = parsed.pathname;

        if (method === 'OPTIONS') return {};
        if (method === 'POST' && path === '/settings') return { success: true };
        if (path === '/settings') {
            return {
                baseUrl: self.location.origin + '/disabled-streaming-server',
                values: {
                    appPath: '',
                    cacheRoot: '',
                    serverVersion: 'xilften-remote-disabled',
                    cacheSize: 0,
                    btMaxConnections: 0,
                    btHandshakeTimeout: 0,
                    btRequestTimeout: 0,
                    btDownloadSpeedSoftLimit: 0,
                    btDownloadSpeedHardLimit: 0,
                    btMinPeersForStable: 0,
                    proxyStreamsEnabled: false,
                    remoteHttps: null,
                    transcodeProfile: null
                }
            };
        }
        if (path === '/network-info') return { availableInterfaces: [] };
        if (path === '/device-info') return { availableHardwareAccelerations: [] };
        if (path === '/casting') return [];
        if (path.includes('/local-addon/manifest.json')) {
            return {
                id: 'org.stremio.local-addon.disabled',
                version: '0.0.0',
                name: 'Local Files',
                resources: [],
                types: [],
                catalogs: []
            };
        }
        if (path.includes('/local-addon/stream/')) return { streams: [] };
        if (path.includes('/local-addon/meta/')) return { meta: null };
        if (path.includes('/local-addon/catalog/')) return { metas: [] };
        if (path.endsWith('/stats.json')) return {};
        if (method === 'POST') return { success: false };
        return {};
    }

    if (originalFetch) {
        self.fetch = function patchedFetch(input, init) {
            const url = requestUrl(input);
            const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
            if (url && (isLocalStreamingServer(url) || isDisabledStreamingServer(url))) {
                return jsonResponse(localStreamingServerPayload(url, method));
            }
            return originalFetch(input, init);
        };
    }
}());

require('./node_modules/@stremio/stremio-core-web/worker.js');
